const VISITOR_EMAIL_SESSION_KEY = 'analytics_visitor_email';

export function cacheVisitorEmail(email) {
  if (typeof window === 'undefined' || !email) return;

  try {
    const normalized = String(email).trim().toLowerCase();
    if (normalized.includes('@')) {
      sessionStorage.setItem(VISITOR_EMAIL_SESSION_KEY, normalized);
    }
  } catch {
    // ignore
  }
}

export function getCachedVisitorEmail() {
  if (typeof window === 'undefined') return '';

  try {
    return sessionStorage.getItem(VISITOR_EMAIL_SESSION_KEY) || '';
  } catch {
    return '';
  }
}

export function getVisitorEmailFromUrl() {
  if (typeof window === 'undefined') return '';

  try {
    const params = new URLSearchParams(window.location.search);
    const fromUrl = (params.get('email') || params.get('e') || '').trim().toLowerCase();
    if (fromUrl && fromUrl.includes('@')) {
      cacheVisitorEmail(fromUrl);
      return fromUrl;
    }
  } catch {
    // ignore
  }

  return '';
}

export function getEmailFromProfile() {
  if (typeof window === 'undefined') return '';

  try {
    const raw = localStorage.getItem('profile');
    if (raw) {
      const profile = JSON.parse(raw);
      const fromProfile = (profile?.result?.email || profile?.email || '').trim().toLowerCase();
      if (fromProfile && fromProfile.includes('@')) return fromProfile;
    }
  } catch {
    // ignore
  }

  return '';
}

/** Profil → URL (?email= / ?e=) → sesija (kampanja / forma). */
export function getVisitorEmail() {
  const fromProfile = getEmailFromProfile();
  if (fromProfile) return fromProfile;

  const fromUrl = getVisitorEmailFromUrl();
  if (fromUrl) return fromUrl;

  try {
    const googleEmail = sessionStorage.getItem('google_email');
    if (googleEmail && googleEmail.includes('@')) return googleEmail.trim().toLowerCase();
  } catch {
    // ignore
  }

  return getCachedVisitorEmail();
}
